import * as React from "react";

function useTypewriter(
  phrases: string[],
  isActive: boolean,
  intervalMs = 2500
): string {
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [displayText, setDisplayText] = React.useState("");
  const [charIndex, setCharIndex] = React.useState(0);

  React.useEffect(() => {
    if (!isActive) {
      setCurrentIndex(0);
      setCharIndex(0);
      setDisplayText("");
      return;
    }

    const currentPhrase = phrases[currentIndex];

    if (charIndex < currentPhrase.length) {
      const typingTimer = setTimeout(() => {
        setDisplayText(currentPhrase.slice(0, charIndex + 1));
        setCharIndex((prev) => prev + 1);
      }, 40);
      return () => clearTimeout(typingTimer);
    }

    const nextPhraseTimer = setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % phrases.length);
      setCharIndex(0);
      setDisplayText("");
    }, intervalMs);

    return () => clearTimeout(nextPhraseTimer);
  }, [isActive, currentIndex, charIndex, phrases, intervalMs]);

  return displayText;
}

export { useTypewriter };
